import { useCallback, useState } from 'react';

import CustomError from 'Utils/CustomError';
import useToastNotifications from 'Hooks/useToastNotifications';

const useAsyncError = () => {
  // eslint-disable-next-line no-unused-vars
  const [_, setError] = useState();
  const toast = useToastNotifications();

  return useCallback(e => {
    if (e?.info?.errors) {
      // Remove duplicate messages by converting to a Set, then back to an array
      const uniqueMessages = [...new Set((e.info.errors || []).map(i => i?.message))];

      // Join unique messages with line breaks
      const messages = uniqueMessages.join('\r\n');

      if (e?.status && e?.status < 500) {
        toast.addNotification({
          type: 'error',
          title: messages,
          timeout: 5000,
        });
      } else {
        setError(() => {
          throw new CustomError(e, messages);
        });
      }
    }
  }, [setError]);
};

export default useAsyncError;
